module.exports = __webpack_public_path__ + "static/pledge-logo-d9b3d93d451f2c283d89cf985966c2f6.png";